<template>
  <StModal :on-close="handleClose">
    <div class="st-bo-ug-number-modal">
      <div class="st-bo-ug-number-modal__title">
        <StHeadline :level="2">Ändra UG Nummer</StHeadline>
      </div>
      <div class="st-bo-ug-number-modal__input">
        <st-form-group
          label="UG Nummer"
          :validation="v$.ugNumber"
          :validation-errors="validationErrors.ugNumber"
        >
          <st-input
            id="ug-number-modal-input-number"
            v-model="newValue.ugNumber"
            type="text"
            tabindex="0"
            required
            :blur="() => handleBlur()"
            :invalid="v$ && v$.ugNumber && v$.ugNumber.$error"
          />
        </st-form-group>
      </div>
      <div class="st-bo-ug-number-modal__buttons">
        <st-button
          rectangular
          secondary
          full-width
          @click="handleClose"
          tabindex="0"
        >
          Avbryt
        </st-button>
        <st-button
          rectangular
          full-width
          @click="handleUpdate"
          tabindex="0"
          :is-loading="isLoading"
        >
          Spara
        </st-button>
      </div>
    </div>
  </StModal>
</template>
<script>
import {
  StModal,
  StButton,
  StInput,
  StFormGroup,
  StHeadline,
} from "skanetrafiken";
import { computed, ref, onMounted } from "vue";
import { useAccount } from "@/composables/useAccount";
import ChangeAccountDetailsValidations from "@/validators/change-account-details-validations";
import ChangeAccountDetailsValidationsErrors from "@/validators/change-account-details-validations-errors";
import { useVuelidate } from "@vuelidate/core";
import { CLOSE } from "@/constants";
export default {
  name: "st-bo-ug-number-modal",
  components: {
    StModal,
    StButton,
    StInput,
    StFormGroup,
    StHeadline,
  },
  props: {
    isLoading: Boolean,
  },
  setup(_, { emit }) {
    const account = useAccount();
    const newValue = ref({ ugNumber: "" });

    const v$ = useVuelidate(ChangeAccountDetailsValidations, newValue);

    onMounted(() => {
      newValue.value.ugNumber = account.state.account.ugNumber.toString();
    });

    const handleClose = () => {
      newValue.value.ugNumber = account.state.account.ugNumber;
      emit(CLOSE);
    };

    const handleBlur = () => {
      v$.value.ugNumber.$touch();
    };

    const handleUpdate = () => {
      v$.value.$touch();
      const errors = v$.value.$errors;
      if (errors.length) return;
      emit("updateUgNumber", newValue.value.ugNumber);
    };

    return {
      account: computed(() => account.state.account),
      newValue,
      handleClose,
      v$,
      handleBlur,
      validationErrors: ChangeAccountDetailsValidationsErrors,
      handleUpdate,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~skanetrafiken/dist/scss/main.scss";
.st-bo-ug-number-modal {
  &__title {
    text-align: center;
  }

  &__input {
    text-align: left;
    margin: rem-calc(30) 0;
  }

  &__buttons {
    display: flex;
    flex-direction: row;

    & > :last-child {
      margin-left: rem-calc(10);
    }
  }
}
</style>
